import Head from 'next/head';
import user from '../../../src/services/api/user';
import priceApi from '../../../src/services/api/prices';
import quoteApi from '../../../src/services/api/quotes';
import countryApi from '../../../src/services/api/countries';

import SupportForm from '../../../src/components/common/elements/SupportForm';
import { baseUrlOf, redirect } from '../../../src/lib/ssr';
import Footer from '../../../src/components/common/Footer';
import Header from '../../../src/components/common/Header';
import Simulation from '../../../src/components/assurance/simulation/Simulation';
import { HREF as TRAVELERS_HREF } from './voyageurs';

const TITLE = 'YUPWEGO - Simulez votre voyage - Vos destinations';
const DESCRIPTION = `Simulez le coût de votre assurance voyage avec YUPWEGO, commencez par entrer vos destinations`;

const HREF = '/assurance/simulation/tarif';

const Index = ({ profile, currentUrl, countries, prices, quote }) => (
  <>
    <Head>
      <title key="title">{TITLE}</title>
      <meta key="og:type" content="page" property="og:type" />
      <meta key="og:title" content={TITLE} property="og:title" />
      <meta
        key="og:description"
        content="L'assurance voyage flexible et sans contraintes, simulez le coût de votre assurance"
        property="og:description"
      />
      <meta key="og:url" content={currentUrl} property="og:url" />
      <meta key="twitter:card" name="twitter:card" content="summary" />
      <meta key="twitter:title" name="twitter:title" content={TITLE} />
      <meta
        key="twitter:description"
        name="twitter:description"
        content={DESCRIPTION}
      />
      <link rel="stylesheet" href="/static/styles/flags.css" />
    </Head>
    <Header profile={profile} />
    <Simulation
      step="pricing"
      countries={countries}
      quote={quote}
      prices={prices}
    />
    <Footer />
    <SupportForm />
  </>
);

Index.getInitialProps = async ({ req, res }) => {
  const baseUrl = baseUrlOf(req);
  const currentUrl = `${baseUrl}${HREF}`;
  const [profile, quote, countries, prices] = await Promise.all([
    user.profile(req, res),
    quoteApi.get(req, res),
    countryApi.get(req),
    priceApi.get(req)
  ]);
  if (quote.beneficiaries && quote.beneficiaries.length > 0) {
    return {
      profile,
      currentUrl,
      countries,
      prices,
      quote
    };
  } else {
    redirect(res, TRAVELERS_HREF);
  }
};

export default Index;
export { HREF };
